// Misc Actions

export const setBaseUrls = ({ commit }, payload) => {
  commit('setBaseUrls', payload)
}

export const setDisplayGreeting = ({ commit }, payload) => {
  commit('setDisplayGreeting', payload)
}
